// SEO / AEO location content for neighborhoods served by Detour Coffee Co.
// Each entry powers a dedicated /coffee-shop/:slug page with blog-style copy,
// FAQs (FAQPage schema) and internal links.

export const SITE_URL = "https://detourcoffeeco.com";

export const LOCATIONS = [
  {
    slug: "virginia-square",
    name: "Virginia Square",
    region: "Arlington, Virginia",
    distance: "right in the heart of Virginia Square",
    metro: "steps from the Virginia Square–GMU Metro on the Orange & Silver lines",
    lead: "Detour Coffee Co. is Virginia Square's neighborhood café — handcrafted coffee and a Mediterranean kitchen, open early to late.",
    paras: [
      "Detour Coffee Co. calls Virginia Square home. Our doors at 946 N Jackson St sit in the middle of the neighborhood, just off Wilson Boulevard, so whether you're grabbing a Habibi Latte on your way to the Metro or settling in for the afternoon, you're never more than a short walk away.",
      "Mornings here start with fresh pastries and our full breakfast menu; afternoons bring Mediterranean mezze, sandwiches and salads; and weekends mean brunch with cast-iron knafeh and shakshuka. It's the kind of place Virginia Square regulars treat like a second living room.",
    ],
    gettingHere:
      "From anywhere in Virginia Square you can walk to Detour in just a few minutes. Street parking is available along N Jackson St and the surrounding blocks, and the Virginia Square–GMU Metro is one block away.",
    faqs: [
      {
        q: "Where is the best coffee shop in Virginia Square, Arlington?",
        a: "Detour Coffee Co. at 946 N Jackson St is Virginia Square's go-to coffee shop, serving specialty espresso drinks, a Mediterranean-inspired kitchen and fresh pastries seven days a week from 7:30 AM to 10 PM.",
      },
      {
        q: "Is Detour Coffee Co. near the Virginia Square–GMU Metro?",
        a: "Yes. Detour Coffee Co. is about a one-block walk from the Virginia Square–GMU Metro station on the Orange and Silver lines, making it an easy stop before or after your commute.",
      },
    ],
  },
  {
    slug: "westover",
    name: "Westover",
    region: "Arlington, Virginia",
    distance: "a short 5-minute drive east of Westover Village",
    metro: "an easy drive or bike ride down Washington Boulevard",
    lead: "A quick trip from Westover Village for specialty coffee, brunch and a warm place to work.",
    paras: [
      "Westover neighbors love that Detour Coffee Co. is only a few minutes away. Trade the walk to your usual spot for a proper Mediterranean café — signature lattes, house-baked pastries and a kitchen that runs all day at 946 N Jackson St in nearby Virginia Square.",
      "It's a favorite weekend destination for Westover families, with brunch served Saturday and Sunday and plenty of seating indoors and on the patio. Bring the laptop on a weekday and stay a while — the WiFi is fast and we're open until 10 PM.",
    ],
    gettingHere:
      "From Westover Village, head east on Washington Boulevard toward Virginia Square — Detour is about five minutes away with street parking nearby and the Metro one block over.",
    faqs: [
      {
        q: "Is there a good coffee shop near Westover, Arlington?",
        a: "Detour Coffee Co. is just a five-minute drive from Westover Village at 946 N Jackson St. It's a full Mediterranean café with specialty coffee, all-day food and weekend brunch, open daily 7:30 AM–10 PM.",
      },
      {
        q: "Does Detour serve brunch for Westover residents?",
        a: "Yes — Detour Coffee Co. serves weekend brunch every Saturday and Sunday until 5 PM, including shakshuka, short rib hash and Dubai toast, a short drive from Westover.",
      },
    ],
  },
  {
    slug: "clarendon",
    name: "Clarendon",
    region: "Arlington, Virginia",
    distance: "less than a mile west of Clarendon",
    metro: "a quick ride from the Clarendon Metro",
    lead: "An easy escape from the Clarendon buzz — quality coffee, Mediterranean plates and room to breathe.",
    paras: [
      "When Clarendon feels a little too busy, Detour Coffee Co. is the calmer, warmer alternative just up the road. You get the same central Arlington convenience with a distinctly local, hospitable feel — plus a menu that goes well beyond coffee.",
      "Meet a friend for mezze and wine, pull up with a book and a Detour Delight Latte, or fuel a work session with our chili-crisp chicken sandwich. Clarendon regulars keep coming back for the food as much as the coffee.",
    ],
    gettingHere:
      "From Clarendon, it's a short trip west along Wilson or Clarendon Boulevard to 946 N Jackson St. Park on the street or hop the Metro one stop to Virginia Square–GMU.",
    faqs: [
      {
        q: "What's a good coffee shop near Clarendon, Arlington?",
        a: "Detour Coffee Co., less than a mile west of Clarendon at 946 N Jackson St, is a beloved local café serving specialty coffee, Mediterranean food and weekend brunch daily from 7:30 AM to 10 PM.",
      },
      {
        q: "Is Detour a good spot for a date or catch-up near Clarendon?",
        a: "Absolutely. Detour offers mezze plates, wine and cocktails alongside its coffee menu, making it a relaxed alternative to Clarendon's busier bars — just minutes away.",
      },
    ],
  },
  {
    slug: "ballston",
    name: "Ballston",
    region: "Arlington, Virginia",
    distance: "under a mile east of Ballston Quarter",
    metro: "a few minutes from Ballston–MU Metro",
    lead: "Ballston's easy detour for great coffee, an all-day Mediterranean kitchen and catering for the office.",
    paras: [
      "For Ballston workers and residents, Detour Coffee Co. is the neighborhood café worth the short trip east. Start the morning with a breakfast burrito and a cortado, or bring the whole team — we cater coffee and Mediterranean platters across Ballston.",
      "The atmosphere is built for getting things done: strong WiFi, plenty of outlets and generous tables, open late every night. It's why so many Ballston remote workers make Detour their home base.",
    ],
    gettingHere:
      "From Ballston Quarter, head east toward Virginia Square — Detour is under a mile away at 946 N Jackson St, with street parking and the Metro close by.",
    faqs: [
      {
        q: "Where can I get good coffee near Ballston, Arlington?",
        a: "Detour Coffee Co. at 946 N Jackson St is under a mile from Ballston Quarter, serving specialty espresso, Mediterranean food and pastries every day from 7:30 AM to 10 PM.",
      },
      {
        q: "Does Detour Coffee Co. cater to offices in Ballston?",
        a: "Yes. Detour offers office catering, coffee service and Mediterranean platters for meetings and events throughout the Ballston area — reach out through our contact page to plan.",
      },
    ],
  },
  {
    slug: "courthouse",
    name: "Courthouse",
    region: "Arlington, Virginia",
    distance: "about a mile from Courthouse",
    metro: "a short hop from the Courthouse Metro",
    lead: "A warm, local coffee shop a short trip from Courthouse — great for meetings, remote work and weekend brunch.",
    paras: [
      "Courthouse neighbors and county professionals find Detour Coffee Co. an easy, welcoming detour. Grab a quick espresso between meetings or settle in for a longer stretch with lunch from our Mediterranean kitchen.",
      "We're open early for the commute and late into the evening, with weekend brunch that's become a Courthouse-area favorite. Come for the coffee, stay for the knafeh.",
    ],
    gettingHere:
      "From Courthouse, travel west along Wilson Boulevard toward Virginia Square — Detour sits at 946 N Jackson St, roughly a mile away, with the Metro and street parking nearby.",
    faqs: [
      {
        q: "Is there a good coffee shop near Courthouse, Arlington?",
        a: "Detour Coffee Co. is about a mile from Courthouse at 946 N Jackson St, offering specialty coffee, an all-day Mediterranean menu and weekend brunch, open daily 7:30 AM–10 PM.",
      },
      {
        q: "Can I hold a casual meeting at Detour near Courthouse?",
        a: "Yes — with fast WiFi, ample seating and a full food and coffee menu, Detour is a comfortable spot for informal meetings a short trip from Courthouse.",
      },
    ],
  },
  {
    slug: "rosslyn",
    name: "Rosslyn",
    region: "Arlington, Virginia",
    distance: "a short drive west of Rosslyn",
    metro: "a straight shot down Wilson Boulevard from Rosslyn",
    lead: "Trade the Rosslyn high-rises for a warm neighborhood café with real Mediterranean cooking.",
    paras: [
      "Rosslyn commuters and residents love escaping to Detour Coffee Co. for a more personal coffee experience. It's a genuine neighborhood café — handcrafted espresso, house-baked pastries and a kitchen that runs from breakfast through dinner.",
      "Whether you're working near Key Bridge or heading home along Wilson Boulevard, Detour is an easy stop for a Yaffa Matcha or a full Mediterranean spread, open until 10 PM every night.",
    ],
    gettingHere:
      "From Rosslyn, follow Wilson Boulevard west toward Virginia Square — Detour is at 946 N Jackson St, with street parking and the Virginia Square–GMU Metro nearby.",
    faqs: [
      {
        q: "Where's a good coffee shop near Rosslyn, Arlington?",
        a: "Detour Coffee Co. at 946 N Jackson St is a short drive west of Rosslyn, serving specialty coffee, Mediterranean food and weekend brunch daily from 7:30 AM to 10 PM.",
      },
      {
        q: "Is Detour open late for Rosslyn evening plans?",
        a: "Yes — Detour is open until 10 PM every day and serves cocktails and wine alongside coffee, making it an easy evening stop from Rosslyn.",
      },
    ],
  },
  {
    slug: "lyon-village",
    name: "Lyon Village",
    region: "Arlington, Virginia",
    distance: "just minutes from Lyon Village",
    metro: "a short walk or drive from Lyon Village",
    lead: "The friendly neighborhood café Lyon Village residents call their own.",
    paras: [
      "Lyon Village is one of Detour Coffee Co.'s closest neighbors. Families and professionals stroll over for morning coffee, weekend brunch and a warm place to catch up — all just minutes from home.",
      "Our Mediterranean kitchen keeps things fresh all day, from avocado toast and labneh bagels to mezze and lazy pitas in the evening. It's a true community café, and Lyon Village regulars are a big part of it.",
    ],
    gettingHere:
      "From Lyon Village, it's a quick walk or drive to 946 N Jackson St in Virginia Square, with street parking on the surrounding blocks.",
    faqs: [
      {
        q: "What coffee shop is closest to Lyon Village, Arlington?",
        a: "Detour Coffee Co. at 946 N Jackson St is just minutes from Lyon Village and serves specialty coffee, Mediterranean food and pastries daily from 7:30 AM to 10 PM.",
      },
      {
        q: "Is Detour family-friendly for Lyon Village residents?",
        a: "Yes — Detour is a welcoming, community-focused café with all-day food, weekend brunch and both indoor and patio seating, a short trip from Lyon Village.",
      },
    ],
  },
  {
    slug: "ashton-heights",
    name: "Ashton Heights",
    region: "Arlington, Virginia",
    distance: "a few minutes from Ashton Heights",
    metro: "an easy walk or short drive from Ashton Heights",
    lead: "Ashton Heights' neighborhood spot for specialty coffee and Mediterranean comfort food.",
    paras: [
      "Ashton Heights sits right beside Virginia Square, so Detour Coffee Co. is essentially your corner café. Pop in for a Habibi Chai on a morning walk, or make it your standing weekend brunch tradition.",
      "With a Mediterranean kitchen open all day and a relaxed, light-filled space, Detour has become a daily habit for many Ashton Heights neighbors — coffee lovers and remote workers alike.",
    ],
    gettingHere:
      "From Ashton Heights, walk or drive a few minutes north to 946 N Jackson St. Street parking is available and the Metro is one block away.",
    faqs: [
      {
        q: "Where's the nearest coffee shop to Ashton Heights, Arlington?",
        a: "Detour Coffee Co. at 946 N Jackson St borders Ashton Heights in Virginia Square, serving specialty coffee, Mediterranean food and brunch daily from 7:30 AM to 10 PM.",
      },
      {
        q: "Is Detour a good work-from-café spot near Ashton Heights?",
        a: "Yes — Detour offers fast WiFi, plenty of outlets, roomy tables and late hours, making it an ideal remote-work spot minutes from Ashton Heights.",
      },
    ],
  },
  {
    slug: "ballston-mu",
    name: "Ballston–MU",
    region: "Arlington, Virginia",
    distance: "a few minutes from the Ballston–MU Metro",
    metro: "one stop from Ballston–MU on the Orange & Silver lines",
    lead: "A quick Metro ride from Ballston–MU to specialty coffee and an all-day Mediterranean kitchen.",
    paras: [
      "Riding through Ballston–MU? Detour Coffee Co. is an easy connection — just one Metro stop or a few minutes by car to Virginia Square. It's the perfect commuter café for a morning espresso or an evening bite.",
      "Our menu runs all day, from breakfast burritos to lazy pitas and desserts, with coffee, wine and cocktails to match. Fast WiFi and late hours make it a natural stop for Ballston–MU commuters and remote workers.",
    ],
    gettingHere:
      "From the Ballston–MU Metro, ride one stop east to Virginia Square–GMU or drive a few minutes to 946 N Jackson St, where street parking is available.",
    faqs: [
      {
        q: "Is there a coffee shop near the Ballston–MU Metro?",
        a: "Detour Coffee Co. at 946 N Jackson St is a few minutes from the Ballston–MU Metro — one stop east to Virginia Square–GMU — serving specialty coffee and Mediterranean food daily 7:30 AM–10 PM.",
      },
      {
        q: "Is Detour convenient for Ballston–MU commuters?",
        a: "Yes — Detour is a short Metro ride or drive from Ballston–MU, open early and late, ideal for coffee before your commute or dinner on the way home.",
      },
    ],
  },
  {
    slug: "gmu-arlington",
    name: "GMU Arlington",
    region: "Arlington, Virginia",
    distance: "next to the George Mason University Arlington campus",
    metro: "steps from GMU's Arlington campus and the Virginia Square–GMU Metro",
    lead: "The go-to study café for George Mason University's Arlington campus — coffee, WiFi and a full kitchen.",
    paras: [
      "George Mason University's Arlington campus sits right beside Detour Coffee Co. For students, faculty and staff, it's the natural place to study, meet or refuel between classes at Founders Hall and the law school.",
      "Grab a matcha and a study seat, split mezze with classmates, or line up catering for a campus event. With fast WiFi, plenty of outlets and hours until 10 PM, Detour keeps the GMU Arlington community caffeinated and fed.",
    ],
    gettingHere:
      "From the GMU Arlington campus, Detour is a short walk to 946 N Jackson St, right by the Virginia Square–GMU Metro station.",
    faqs: [
      {
        q: "What's the best coffee shop near George Mason University's Arlington campus?",
        a: "Detour Coffee Co. at 946 N Jackson St sits beside GMU's Arlington campus, offering specialty coffee, fast WiFi and a Mediterranean kitchen daily from 7:30 AM to 10 PM — ideal for studying.",
      },
      {
        q: "Is Detour a good place for GMU students to study?",
        a: "Yes — with fast WiFi, ample outlets, roomy tables, all-day food and late hours, Detour is a favorite study and meeting spot for the GMU Arlington community.",
      },
    ],
  },
];

// FAQs shared across every location for consistent AEO coverage.
export const SHARED_FAQS = [
  {
    q: "What are Detour Coffee Co.'s hours?",
    a: "Detour Coffee Co. is open every day from 7:30 AM to 10 PM, including weekends.",
  },
  {
    q: "Does Detour Coffee Co. offer catering?",
    a: "Yes — Detour offers office catering, corporate coffee service, breakfast platters and event catering across Arlington and Northern Virginia. Get in touch through our contact page to plan your order.",
  },
  {
    q: "What kind of food does Detour Coffee Co. serve?",
    a: "Detour serves a Mediterranean-inspired menu alongside specialty coffee — breakfast, sandwiches, mezze, lazy pitas, weekend brunch, house-made desserts, plus wine and cocktails.",
  },
];

export const getLocation = (slug) => LOCATIONS.find((l) => l.slug === slug);
